import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./styles/app.scss";
import { getEnvVar } from "utils/env";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Demo from "basic-components/Demo";
import { Tenant } from "utils/tenants";

const container = document.getElementById("root");
const root = createRoot(container);

export const ThemeContext = React.createContext({ theme: "blue" });

const Theme = ({ children }) => {
    const [theme, setTheme] = useState(Tenant.getTheme());

    useEffect(() => {
        document.title = Tenant.getName();
        return () => {};
    }, []);

    useEffect(() => {
        if (theme) {
            document.documentElement.style.setProperty("--colors-primary", `var(--colors-theme-${theme}-primary)`);
            document.documentElement.style.setProperty("--colors-secondary", `var(--colors-theme-${theme}-secondary)`);
            document.documentElement.style.setProperty("--colors-third", `var(--colors-theme-${theme}-third)`);
        }
        return () => {};
    }, [theme]);

    return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};

if (getEnvVar("REACT_APP_MODE") === "storybook") {
    root.render(
        <Theme>
            <Demo />
        </Theme>
    );
} else {
    root.render(
        <Theme>
            <App />
        </Theme>
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
